import React from 'react'
import TwitterIcon from '@material-ui/icons/Twitter';
import { IconButton } from '@material-ui/core';
import Link from '@material-ui/core/Link';
const header = () => {
    return (
        <div>
            <header className="text-gray-600 body-font">
                <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
                    <a className="flex title-font font-medium items-center text-gray-900 mb-4 md:mb-0">
                        <img src="images/logo.svg" className="h-24 -m-6"></img>
                        <span className="text-xl">Photo Fit</span>
                    </a>
                    <nav className="md:ml-auto flex flex-wrap items-center text-base justify-center">
                        <IconButton className="mr-5">
                            <Link href="https://twitter.com/prash2018" color="secondary" style={{ color: '#2f2e41' }} target="_blank" >
                                <TwitterIcon></TwitterIcon>
                            </Link>
                        </IconButton>
                    </nav>
                </div>
            </header>
        </div>
    )
}

export default header
